import { Button, Stack, Typography } from '@mui/material';
import { useDialog } from 'common/hooks/useDialog';
import { useNavigateAfterLogin } from 'common/hooks/useNavigateAfterLogin';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Banner } from 'components/HomePage/Banner/Banner';
import {
  SelectProductTypeDialog,
  SelectProductTypeDialogProps,
} from 'components/products/SelectProductTypeDialog/SelectProductTypeDialog';
import { PRODUCTS_MANAGEMENT_ADD_PRODUCT_URL } from 'const';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import AddProductBannerImageLarge from '../../../assets/images/add-products-banner.svg';
import { styles } from './AddProductBanner.styles';

export const AddProductBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useContext(AuthContext);
  const { navigateAfterLogin } = useNavigateAfterLogin();

  const selectProductType = useDialog<SelectProductTypeDialogProps, void>(SelectProductTypeDialog, {
    instanceId: 'select-product-type-dialog',
    navigable: true,
  });

  const handleExistingProductsClick = () => {
    // workaround: as this switcher is also shown to unregistered client, we don't want to open
    // SelectProductTypeDialog directly for them but redirect to login instead
    isAuthenticated ? selectProductType.create({}) : navigateAfterLogin(PRODUCTS_MANAGEMENT_ADD_PRODUCT_URL);
  };

  return (
    <Stack spacing={8}>
      <Stack alignItems="center" mx={2} spacing={3} textAlign="center">
        <Typography component="div" sx={styles.headline}>
          {t('homepage.products.addProductBanner.header.title')}
        </Typography>
        <Typography textAlign={'center'} variant="bodyStrongL">
          {t('homepage.products.addProductBanner.header.subtitle')}
        </Typography>
        <Button onClick={handleExistingProductsClick} size="large">
          {t('homepage.products.addProductBanner.addButton')}
        </Button>
      </Stack>
      <Banner
        alignItems="center"
        imageSrc={AddProductBannerImageLarge}
        text={t('homepage.products.addProductBanner.text')}
        title={t('homepage.products.addProductBanner.title')}
      />
    </Stack>
  );
};
